import { authGuard } from '@/features/auth/guards/authGuard.js'
import { sessionGuard } from '@/features/auth/guards/sessionGuard.js'
import { clubRegisteredGuard } from '@/features/router/guards/clubRegisteredGuard.js'
import DummyRouter from '@/features/ui/components/DummyRouter.vue'

export const memRegRoutes = [
  {
    beforeEnter: [authGuard, sessionGuard, clubRegisteredGuard],
    path: '',
    component: DummyRouter,
    children: [
      {
        path: 'membership',
        component: () => import('./MemRegView.vue'),
      },
      {
        path: 'membership/:memberRegId',
        component: () => import('./MemRegView.vue'),
      },
    ],
  },
]
